import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import StoreListTopContent from "../../../StoreListTopContent/components/StoreListTopContent/StoreListTopContent.js";
const StoreListTopContentFallback = () => {
  const { getFormattedLabel, getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(
    StoreListTopContent,
    {
      title: getLabel("stores.page.search.title", { hideLabelKey: true }),
      description: getFormattedLabel("stores.page.search.description", {
        hideLabelKey: true,
        parseLink: true
      })
    }
  );
};
export {
  StoreListTopContentFallback,
  StoreListTopContentFallback as default
};
//# sourceMappingURL=StoreListTopContentFallback.js.map
